export default __webpack_public_path__ + "static/media/basketball.2126ce3b.webp";